'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_create', {
        url: 'user_create',
        template: '<end-user-create></end-user-create>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/end_user/create/end_user_create.routes.js